/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { archiveContact } from '../fn/contacts/archive-contact';
import { ArchiveContact$Params } from '../fn/contacts/archive-contact';
import { createContact } from '../fn/contacts/create-contact';
import { CreateContact$Params } from '../fn/contacts/create-contact';
import { deleteContact } from '../fn/contacts/delete-contact';
import { DeleteContact$Params } from '../fn/contacts/delete-contact';
import { ContactDto as FeatureContactsContactDto } from '../models/feature/contacts/contact-dto';
import { getAllContacts } from '../fn/contacts/get-all-contacts';
import { GetAllContacts$Params } from '../fn/contacts/get-all-contacts';
import { unarchiveContact } from '../fn/contacts/unarchive-contact';
import { UnarchiveContact$Params } from '../fn/contacts/unarchive-contact';
import { updateContact } from '../fn/contacts/update-contact';
import { UpdateContact$Params } from '../fn/contacts/update-contact';

@Injectable({ providedIn: 'root' })
export class ContactsClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactsGetAllContacts()` */
  static readonly ContactsGetAllContactsPath = '/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllContacts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllContacts$Response(params?: GetAllContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeatureContactsContactDto>>> {
    const obs = getAllContacts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllContacts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllContacts(params?: GetAllContacts$Params, context?: HttpContext): Observable<Array<FeatureContactsContactDto>> {
    const resp = this.getAllContacts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FeatureContactsContactDto>>): Array<FeatureContactsContactDto> => r.body)
    );
  }

  /** Path part for operation `contactsCreateContact()` */
  static readonly ContactsCreateContactPath = '/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContact$Response(body: CreateContact$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<FeatureContactsContactDto>> {
    const obs = createContact(this.http, this.rootUrl, { body } satisfies CreateContact$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContact(body: CreateContact$Params['body'], context?: HttpContext): Observable<FeatureContactsContactDto> {
    const resp = this.createContact$Response(body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureContactsContactDto>): FeatureContactsContactDto => r.body)
    );
  }

  /** Path part for operation `contactsDeleteContact()` */
  static readonly ContactsDeleteContactPath = '/contacts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContact$Response(id: number, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteContact(this.http, this.rootUrl, { id } satisfies DeleteContact$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContact(id: number, context?: HttpContext): Observable<void> {
    const resp = this.deleteContact$Response(id, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `contactsUpdateContact()` */
  static readonly ContactsUpdateContactPath = '/contacts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContact$Response(id: number, body: UpdateContact$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<FeatureContactsContactDto>> {
    const obs = updateContact(this.http, this.rootUrl, { id, body } satisfies UpdateContact$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContact(id: number, body: UpdateContact$Params['body'], context?: HttpContext): Observable<FeatureContactsContactDto> {
    const resp = this.updateContact$Response(id, body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureContactsContactDto>): FeatureContactsContactDto => r.body)
    );
  }

  /** Path part for operation `contactsArchiveContact()` */
  static readonly ContactsArchiveContactPath = '/contacts/{id}/archive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `archiveContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveContact$Response(id: number, context?: HttpContext): Observable<StrictHttpResponse<FeatureContactsContactDto>> {
    const obs = archiveContact(this.http, this.rootUrl, { id } satisfies ArchiveContact$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `archiveContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveContact(id: number, context?: HttpContext): Observable<FeatureContactsContactDto> {
    const resp = this.archiveContact$Response(id, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureContactsContactDto>): FeatureContactsContactDto => r.body)
    );
  }

  /** Path part for operation `contactsUnarchiveContact()` */
  static readonly ContactsUnarchiveContactPath = '/contacts/{id}/unarchive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `unarchiveContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  unarchiveContact$Response(id: number, context?: HttpContext): Observable<StrictHttpResponse<FeatureContactsContactDto>> {
    const obs = unarchiveContact(this.http, this.rootUrl, { id } satisfies UnarchiveContact$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `unarchiveContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  unarchiveContact(id: number, context?: HttpContext): Observable<FeatureContactsContactDto> {
    const resp = this.unarchiveContact$Response(id, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureContactsContactDto>): FeatureContactsContactDto => r.body)
    );
  }

}
